import { FC, SyntheticEvent, useMemo } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { useMakeDisplayableUsers, UserQueries } from '@portal/pkg-filter-criteria/user'
import { DisplayableUser } from '@portal/pkg-filter-criteria/user'
import { MultiUserSelect } from '@portal/pkg-filter-criteria/user'
import { Loading } from '@portal/pkg-ui'
import { Skeleton, TextField } from '@mui/material'
import { useQuery } from '@tanstack/react-query'

export const FilterCriteriaValueMultiUser: FC<FilterCriteriaValueFieldProps> = ({
  fieldProps: { value, onChange, error, ...fieldProps },
}) => {
  const { data: activeUsers } = useQuery(UserQueries.activeUsers())
  const displayableUsers = useMakeDisplayableUsers(activeUsers)

  const options = useMemo(
    () => displayableUsers.toSorted((a, b) => (b.enabled ? 1 : 0) - (a.enabled ? 1 : 0)),
    [displayableUsers],
  )

  const calculatedValue = useMemo<Array<DisplayableUser>>(
    () =>
      value
        ? value
            .split(/\s*,\s*/)
            .map((idStr: string) => displayableUsers.find((u) => u.identifier === idStr))
        : [],
    [displayableUsers, value],
  )

  const handleChange = (_event: SyntheticEvent, newValue: Array<DisplayableUser>) => {
    const userIdStr = newValue.map((u) => u.identifier).join(',')
    onChange(userIdStr)
  }

  return (
    <Loading
      until={{ activeUsers }}
      fallback={() => <Skeleton variant="rectangular" height={40} />}
    >
      {() => (
        <MultiUserSelect
          renderInput={(params) => <TextField variant="outlined" error={error} {...params} />}
          options={options}
          value={calculatedValue}
          onChange={handleChange}
          compact
          {...fieldProps}
        />
      )}
    </Loading>
  )
}
